export default {
    REACT_WHEN: 0,
    REACTION: 1,
    AFTER_REACTION: 2
};
